/**
 * main.js - Point d'entrée de l'application Preparo
 *
 * Bootstrap de l'application Svelte avec initialisation
 * des styles globaux et de l'application principale.
 */

import "./interface/styles/milkdown-custom.css";
import App from "./App.svelte";

// Initialisation de l'application
const app = new App({
  target: document.getElementById("app"),
  props: {
    // Props initiales si nécessaire
  },
});

// Hot Module Replacement (HMR) pour le développement
if (import.meta.hot) {
  import.meta.hot.accept();
  import.meta.hot.dispose(() => {
    app.$destroy();
  });
}

// Gestion des erreurs globales
window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled promise rejection:", event.reason);
});

window.addEventListener("error", (event) => {
  console.error("Global error:", event.error);
});

// Log de démarrage
console.log(`
╔═══════════════════════════════════════╗
║                                       ║
║   📝 Preparo - Document Manager      ║
║   Version: 1.0.0                      ║
║   Environment: ${import.meta.env.MODE}           ║
║                                       ║
╚═══════════════════════════════════════╝
`);

export default app;
